import { render, staticRenderFns } from "./ControlePonto.vue?vue&type=template&id=3d56ec9c&"
import script from "./ControlePonto.vue?vue&type=script&lang=js&"
export * from "./ControlePonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports